import { showErrorMsg, showSuccessMsg } from "../utils/toast";
import api from "./api";
import { stringifyValues } from "../utils/tableFunctions";
import { Log } from "./services";

// --------------- API Calls for Settlements ----------------------- //

export async function getSettlementList(
  setList,
  setLoaded,
  status,
  download = false,
  filter = {}
) {
  filter = stringifyValues(filter);
  const url = "settlement/admin/settlement/filter/";
  api
    .post(url, {
      ...filter,
      status: status,
      download: download ? "true" : "false",
    })
    .then((response) => {
      if (setList) {
        setList(response.data);
        setLoaded && setLoaded(true);
      }
      return response.data;
    })
    .catch((response) => {
      setList(response.response.data);
      setLoaded && setLoaded(true);
      Log.error(url, filter, response)
      return response.response.data;
    });
}

export async function getSettlementCSV(filter, status) {
  const url = "/settlement/admin/settlement/filter/";
  filter = stringifyValues(filter);
  const data = await api.post(url, {
    download: "true",
    ...filter,
    status: status,
  });
  return data.data;
}

export function getSettlementFilterParams(status, setParams) {
  const url = "/settlement/admin/settlement/filter_conditions/" + status + "/";
  api.get(url).then((response) => {
    setParams(response.data);
  });
}

export function postSettlementFilter(
  setList,
  fMerchantName,
  fDate,
  fBrand,
  fCurrency,
  fNetAmount,
  status,
  download = "false"
) {
  const url = "/settlement/admin/settlement/filter/";
  api
    .post(url, {
      merchant_name: JSON.stringify(fMerchantName),
      start_date: fDate[0].format("YYYY-MM-DD"),
      end_date: fDate[1].format("YYYY-MM-DD"),
      brand: JSON.stringify(fBrand),
      currency: JSON.stringify(fCurrency),
      net_amount_min: fNetAmount[0],
      net_amount_max: fNetAmount[1],
      download: download,
      status: status,
    })
    .then((response) => {
      setList(response.data.results);
    });
}

export function getSettlementDetails(id, setList, setLoaded) {
  const url = "/settlement/admin/settlement/details/" + id + "/";
  api.get(url).then((response) => {
    setList(response.data);
    setLoaded(true);
  });
}

// export function postApprovedSettlement(
//   ids,
//   comment,
//   refresh,
//   oxygen7_id,
//   id = 0
// ) {
//   const url = "/dashboard/settlement/admin/settlement/approved/";
//   const toastId = loadingToast();
//   // Approve Rejected Settlement
//   if (comment !== "") {
//     api
//       .post(url, {
//         pk_list: ids,
//         comment: comment,
//       })
//       .then((response) => {
//         if (!response.data.message) {
//           if (!refresh && id !== 0)
//             window.location.replace(
//               `/3/app/details/settlement/${id}/status?status=approved`
//             );
//           toast.dismiss(toastId);
//           showApproved();
//         } else {
//           showErrorMsg(response.data.message);
//         }
//         if (refresh) window.location.replace("/3/app/settlement/");
//       });
//     // Approve Pending Settlement
//   } else {
//     api
//       .post(url, {
//         pk_list: ids,
//       })
//       .then((response) => {
//         if (!response.data.message) {
//           if (!refresh && id !== 0)
//             window.location.replace(
//               `/3/app/details/settlement/${id}/status?status=approved`
//             );
//           toast.dismiss(toastId);
//           showApproved();
//         } else {
//           showErrorMsg(response.data.message);
//         }
//         if (refresh) window.location.replace("/3/app/settlement/");
//       });
//   }
// }

export function postApprovedSettlement({ pk_list, comment }) {
  const url = "/settlement/admin/settlement/approved/";
  api
    .post(url, { pk_list: JSON.stringify(pk_list), comment: comment })
    .then(() => {
      showSuccessMsg("Settlement Approved Successfully");
    })
    .catch((err) => showErrorMsg(err.response?.data));
}

export function postRejectedSettlement({ pk_list, comment }) {
  const url = "/settlement/admin/settlement/rejected/";
  api
    .post(url, { pk_list: JSON.stringify(pk_list), comment: comment })
    .then(() => {
      showSuccessMsg("Settlement Rejected");
    })
    .catch((err) => showErrorMsg(err.response?.data));
}

// export function postRejectedSettlement(ids, comment, refresh, oxygen7_id, id) {
//   const url = "/dashboard/settlement/admin/settlement/rejected/";
//   const toastId = loadingToast();
//   api
//     .post(url, {
//       pk_list: ids,
//       comment: comment,
//     })
//     .then((response) => {
//       if (!response.data.message) {
//         if (!refresh && id !== 0)
//           window.location.replace(
//             `/3/app/details/settlement/${id}/status?status=rejected`
//           );
//         toast.dismiss(toastId);
//         showRejected();
//       } else {
//         showErrorMsg(response.data.message);
//       }
//     });
// }
